module.exports = __webpack_public_path__ + "img/map.352142be.png";